export const aleksandraTrzcinska = {
    'meta': {
        'title': 'Psychoterapeuta młodzieży i dorosłych Aleksandra Trzcinska',
        'description': 'Jestem psychologiem i psychoterapeutą w trakcie czteroletniego szkolenia z zakresu psychoterapii poznawczo–behawioralnej. Pracuję z młodzieżą oraz dorosłymi.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-aleksandra-trzcinska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/aleksandra-trzcinska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Toruniu, Psychoterapeuta w Toruniu Aleksandra Trzcinska'
        }
    }
}